import { Icon, IconProps } from "..";

export const Kneepads = (props: IconProps) => {
  return (
    <Icon viewBox="0 0 24 24" {...props}>
      <>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M15 5V6H14V7H13V6H7V7H6V8H5V15H6V18H7V19H13V18H14V15H15V17H16V18H18V14H19V12H17V11H19V10H17V9H19V7H18V6H17V5H15ZM13 10V15H14V10H13ZM12 10H13V7H12V10ZM12 10H8V11H12V10ZM12 12V13H8V12H12Z"
          fill="currentColor"
        />
      </>
    </Icon>
  );
};
